import { useNotification } from 'hooks'
import s from '../../../commonStyles.modules.scss'
import { useMemo, useState } from 'react'
import { Table } from 'components/core-ui/Table'
import { columns, drawerFilters, toolbarActions } from './helpers'
import { makeCoreGetFileRequest, makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { toTableRowItems } from './serializers'
import { formatErrorMessage } from 'utils/formatting'
import { formatAndDownloadResponse } from 'utils/helpers'
import { getShopOptionsWithReturoId } from '../../api'

const InProgressSeals = () => {
  const { showNotification } = useNotification()
  const [tableItems, setTableItems] = useState<ReturoSeal[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [isExcelExportLoading, setIsExcelExportLoading] = useState<boolean>(false)

  const { data: shopOptions } = getShopOptionsWithReturoId(showNotification)

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/shop-reception/returo-inventoried-seals',
          tableFilters,
          extraCustomUrlParams: [{ name: 'status', value: 'INVENTORIED' }],
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `Error while fetching table data. ${formatErrorMessage(error)}`,
        type: 'error'
      })
      setIsLoading(false)
    }
  }

  const exportFileExcel = async (tableState, e) => {
    setIsExcelExportLoading(true)
    const { filters, order, orderBy } = tableState
    const url = toTableGETUrl({
      url: '/shop-reception/returo-inventoried-seals/export',
      tableFilters: filters,
      extraCustomUrlParams: [{ name: 'status', value: 'INVENTORIED' }],
      order,
      orderBy
    })

    try {
      const response = await makeCoreGetFileRequest(url, {
        responseType: 'blob'
      })
      formatAndDownloadResponse(response)
      setIsExcelExportLoading(false)
    } catch (error) {
      setIsExcelExportLoading(false)
      showNotification({
        message: `A aparut o eroare la descarcarea fisierului. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const toolbar = useMemo(
    () =>
      toolbarActions({
        totalCount,
        exportFileExcel: exportFileExcel,
        isExcelExportLoading
      }),
    [totalCount, isExcelExportLoading]
  )

  const filters = useMemo(() => drawerFilters(shopOptions), [shopOptions])

  return (
    <div className={s.mainContainer}>
      <Table
        hideCheckbox
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        toolbarActions={toolbar}
        rowActionsWidth="130px"
        filters={filters}
        filtersLabel="Filtreaza"
        filtersButtonLabel="Filtreaza"
        appliedFiltersLabel="Filtre"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </div>
  )
}

export default InProgressSeals
